import { ITypographyComponentProps, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import * as style from './styles.css';
import { IUtpItemWithPercent } from 'shared/types/utp';
import { clsx } from 'clsx';
import { TMortrageState } from 'shared/types/mortrage';

interface IDiscountConditionItemProps extends IUtpItemWithPercent {
  device: TDeviceType;
  Title: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  Description: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  Percent: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  mortrageInfo: TMortrageState;
}

export const DiscountConditionItem: React.FC<IDiscountConditionItemProps> = ({
  title,
  descr,
  percent,
  basePercent,
  notice,
  device,
  Title,
  Description,
  Percent,
}) => {
  return (
    <div className={clsx(style['item'], style[device])}>
      {notice && <div className={style['notice']}>{notice}</div>}
      <div className={style['text-block']}>
        <div className={style['title']}>
          <Title>{title}</Title>
        </div>
        {descr && (
          <div className={style['descr']}>
            <Description>{descr}</Description>
          </div>
        )}
      </div>
      <div className={style['percent']}>
        <Percent color="decorative__theme__blue">{percent}</Percent>
        {basePercent && <div className={style['base-percent']}>{basePercent}</div>}
      </div>
    </div>
  );
};
